import React from 'react'

function Zoom() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 16 16"
        >
            <g fill="#fff" clipPath="url(#clip0_1288_1658)">
                <path d="M15.607 13.727L12.8 10.92a6.986 6.986 0 10-1.887 1.887l2.814 2.806a1.333 1.333 0 002.27-.943 1.334 1.334 0 00-.39-.943zM7 1.333A5.667 5.667 0 111.333 7 5.673 5.673 0 017 1.333z"></path>
                <path d="M4.667 7.667h1.666v1.666a.667.667 0 001.334 0V7.667h1.666a.667.667 0 000-1.334H7.667V4.667a.667.667 0 00-1.334 0v1.666H4.667a.667.667 0 000 1.334z"></path>
            </g>
            <defs>
                <clipPath id="clip0_1288_1658">
                    <path fill="#fff" d="M0 0H16V16H0z"></path>
                </clipPath>
            </defs>
        </svg>
    )
}

export default Zoom
